import * as React from 'react';

export const InfoBoxTexts = {
    Produktionsoversigt: (
        <div>            
            <ul style={{ paddingLeft: '20px', margin: '8px 0' }}>
                <li>Vælg år for at se produktionsdata</li>
                <li>Indtast månedlige produktions- og reguleringsværdier</li>
                <li>"I alt" beregnes automatisk (produktion + regulering)</li>
                <li>Angiv månedlige garantier for hver mølle</li>
                <li>"År til dato i %" viser performance vs. garanti</li>
                <li>Redigér "Gen. DK" værdier for at opdatere gennemsnit</li>
            </ul>
            <em>Tip: Alle ændringer gemmes automatisk når du forlader et felt.</em>
        </div>
    ),
    Skattegrundlag: (
        <div>TODO</div>
    ),

    Skattegrundlag_Opret: (
        <div>TODO</div>
    )
};

export default InfoBoxTexts;
